
































import { Component, Prop, Watch, Vue } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxStateStoring,
  DxColumnFixing,
} from 'devextreme-vue/data-grid';
import {
  DxSwitch,
} from 'devextreme-vue';
import { IArticle, SalesPrice, ArticleStatus, ProgressStatement } from '@/data/web-api-client';

@Component({
    components: {
        DxDataGrid,
        DxSwitch,
        DxColumn,
        DxEditing,
        DxStateStoring,
        DxColumnFixing,
    },
})
export default class ProgressStatementsArticleSummaryTable extends Vue {
    @Prop({required: true})
    private statement!: ProgressStatement;

    private hideInactiveArticles: boolean = true;

    @Prop({required: true})
    private summary!: Array<{
      articleId: string,
      quantity: number,
      unitPrice: number,
    }>;

    private getArticleSalesPrice(articleId: string) {
        if (!this.statement) {
            return null;
        }

        const article = this.articles.find((o: IArticle) => o.id === articleId);

        if (article && article.variants && article.variants.length > 0) {
            const variant =  article.variants[0]; // .find((o) => o.name === variantName);
            if (variant && variant.salesPrices) {
                const type: string = this.statement.projectType ? this.statement.projectType : '';
                const salesPrice =  variant.salesPrices.find((o) => o.type === type);
                if (salesPrice) {
                return salesPrice;
                }
            }
        }

        return null;
    }

    private updateRow(e: any) {
        const self = this;
        e.cancel = new Promise(async (resolve, reject) => {
        try {
            // PRICE CHANGE
            if (e.newData.unitPrice) {
                if (this.statement && this.statement.blocks) {
                    this.statement.blocks.forEach((block) => {
                        if (block.lines) {
                            block.lines.forEach((line) => {
                                if (line.articleId === e.oldData.articleId) {
                                    line.price = e.newData.unitPrice;
                                }
                            });
                        }
                    });
                }
            }

            // ARTICLE CHANGE
            if (e.newData.articleId) {
                if (this.statement && this.statement.blocks) {
                    this.statement.blocks.forEach((block) => {
                        if (block.lines) {
                            block.lines.forEach((line) => {
                                if (line.articleId === e.oldData.articleId) {
                                    const article = self.articles.find((o: IArticle) => o.id === e.newData.articleId);
                                    if (article) {
                                        line.articleId = e.newData.articleId;
                                        line.description = `${article.name}: ${article.description}`;
                                    }
                                }
                            });
                        }
                    });
                }
            }

            resolve(false);
        } catch (err) {
            notificationService.showErrorMessage('Er is iets misgelopen');
            reject(true);
        }
        });
    }

    private setTextColor(e: any) {
        // price
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 2) {
          const salesPrice: SalesPrice | null = this.getArticleSalesPrice(e.data.articleId);

          if (salesPrice && salesPrice !== null) {
            if (e.data.unitPrice < salesPrice.price!) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.unitPrice > salesPrice.price!) {
                $(e.cellElement).addClass('text-success');
            }
          }
        }

        // margin
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 4) {
          const salesPrice = this.getArticleSalesPrice(e.data.articleId);

          if (salesPrice) {
            if (e.data.unitPrice < salesPrice.cost!) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.unitPrice > salesPrice.cost!) {
                $(e.cellElement).addClass('text-success');
            }
          }
        }

        // Total margin
        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 5) {
          const salesPrice = this.getArticleSalesPrice(e.data.articleId);

          if (salesPrice) {
            if (e.data.unitPrice < salesPrice.cost!) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.unitPrice > salesPrice.cost!) {
                $(e.cellElement).addClass('text-success');
            }
          }
        }

        if (e.rowType === 'data' && e.columnIndex && e.columnIndex === 6) {
          const salesPrice = this.getArticleSalesPrice(e.data.articleId);

          if (salesPrice) {
            if (e.data.unitPrice < salesPrice.cost!) {
                $(e.cellElement).addClass('text-danger');
            }
            if (e.data.unitPrice > salesPrice.cost!) {
                $(e.cellElement).addClass('text-success');
            }
          }
        }
    }

    get articles(): IArticle[] {
      const articles: IArticle[] = this.$store.getters['articles/items'];
      if (this.hideInactiveArticles) {
              return articles.filter((o) => o.status === ArticleStatus.Active);
      }

      return articles;
    }

    get summaryColumns() {
        const self = this;
        return [
        {
            dataField: 'articleId',
            caption: 'Code',
            lookup: {
                dataSource: this.articles,
                displayExpr(val: any) {
                    return `${val.name}: ${val.description}`;
                },
                allowClearing: false,
                valueExpr: 'id',
            },
            /*editorOptions: {
                disabled: true,
            },
            calculateDisplayValue(o: {
                articleId: string,
                quantity: number,
                unitPrice: number,
            }) {
                const article = self.articles.find((a) => a.id === o.articleId);
                return article ? `${article.name} - ${article.description}` : '';
            },*/
        },
        {
            dataField: 'quantity',
            caption: 'Aantal',
            dataType: 'number',
            format: {
                precision: 2,
            },
            alignment: 'left',
            editorOptions: {
                disabled: true,
            },
        },
        {
            caption: 'Stukprijs',
            columns: [
            {
                dataField: 'unitPrice',
                caption: 'Stukprijs',
                dataType: 'number',
                format: {
                type: 'currency',
                precision: 2,
                },
                alignment: 'left',
            },
            {
                caption: 'Origineel',
                format: {
                type: 'currency',
                precision: 2,
                },
                alignment: 'left',
                calculateCellValue(value: {
                    articleId: string,
                    quantity: number,
                    unitPrice: number,
                }) {
                    const article = self.articles.find((a) => a.id === value.articleId);
                    if (!article) { return 0; }

                    if (value && article.variants!.length > 0) {
                        const variant = article.variants![0]; // .find((o) => o.name === value.variant);
                        if (!variant) { return 0; }
                        const salesPrice = variant.salesPrices!.find((o) => o.type === self.statement.projectType);
                        if (!salesPrice) { return 0; }
                        return salesPrice.price;
                    }

                    return 0;
                },
            },
            ],
        },
        {
            caption: 'Marge',
            columns: [
                {
                    caption: 'Marge',
                    format: {
                    type: 'currency',
                    precision: 2,
                    },
                    alignment: 'left',
                    calculateCellValue(value: {
                        articleId: string,
                        quantity: number,
                        unitPrice: number,
                    }) {
                        const article = self.articles.find((a) => a.id === value.articleId);
                        if (!article) { return 0; }

                        if (value && article.variants!.length > 0) {
                            const variant = article.variants![0]; // .find((o) => o.name === value.variant);
                            if (!variant) { return 0; }
                            const salesPrice = variant.salesPrices!.find((o) => o.type === self.statement.projectType);
                            if (!salesPrice) { return 0; }
                            return value.unitPrice - salesPrice.cost!;
                        }

                        return 0;
                    },
                },
                {
                    caption: '%',
                    format: {
                        type: 'percent',
                        precision: 2,
                    },
                    alignment: 'left',
                    calculateCellValue(value: {
                        articleId: string,
                        quantity: number,
                        unitPrice: number,
                    }) {
                        const article = self.articles.find((a) => a.id === value.articleId);
                        if (!article) { return 0; }

                        if (value && article.variants!.length > 0) {
                            const variant = article.variants![0];
                            if (!variant) { return 0; }
                            const salesPrice = variant.salesPrices!.find((o) => o.type === self.statement.projectType);
                            if (!salesPrice) { return 0; }
                            return (value.unitPrice - salesPrice.cost!) / salesPrice.cost!;
                        }

                        return 0;
                    },
                },
                {
                    caption: 'Totaal',
                    format: {
                    type: 'currency',
                    precision: 2,
                    },
                    alignment: 'left',
                    calculateCellValue(value: {
                        articleId: string,
                        quantity: number,
                        unitPrice: number,
                    }) {
                        const article = self.articles.find((a) => a.id === value.articleId);
                        if (!article) { return 0; }

                        if (value && article.variants!.length > 0) {
                            const variant = article.variants![0];
                            if (!variant) { return 0; }
                            const salesPrice = variant.salesPrices!.find((o) => o.type === self.statement.projectType);
                            if (!salesPrice) { return 0; }
                            return (value.unitPrice - salesPrice.cost!) * value.quantity;
                        }

                        return 0;
                    },
                },
            ],
        },
        {
            caption: 'Totaal',
            format: {
            type: 'currency',
            precision: 2,
            },
            alignment: 'left',
            calculateCellValue(value: {
                articleId: string,
                quantity: number,
                unitPrice: number,
            }) {
                    if (value) {
                        return value.unitPrice * value.quantity;
                    }

                    return 0;
                },
        },
        ];
    }
}
